import React from "react";

// Official-style Apple logo (single path).
export function AppleLogo({ className = "w-7 h-7", color = "currentColor" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill={color}
      aria-hidden="true"
    >
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

// Official Google Play multicolor triangle.
export function GooglePlayLogo({ className = "w-6 h-6" }) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="gp-blue" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00C3FF" />
          <stop offset="100%" stopColor="#1A73E8" />
        </linearGradient>
        <linearGradient id="gp-red" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF3A44" />
          <stop offset="100%" stopColor="#C31162" />
        </linearGradient>
        <linearGradient id="gp-yellow" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FFE000" />
          <stop offset="100%" stopColor="#FFBD00" />
        </linearGradient>
        <linearGradient id="gp-green" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00F076" />
          <stop offset="100%" stopColor="#00A85A" />
        </linearGradient>
      </defs>
      {/* Blue (left wedge) */}
      <path
        fill="url(#gp-blue)"
        d="M55.6 26.4c-7.3 4-12 11.5-12 20.5v418.2c0 9 4.7 16.5 12 20.5l250.9-229.6L55.6 26.4z"
      />
      {/* Yellow (right wedge) */}
      <path
        fill="url(#gp-yellow)"
        d="M431.2 256l-95.2-55-50.5 56 50.5 56 95.2-55c14.5-8.4 14.5-29.7 0-38z"
      />
      {/* Red (bottom) */}
      <path
        fill="url(#gp-red)"
        d="M306.5 256.1L55.6 485.6c4.8 2.6 10.8 2.5 17.4-1.3l263-152.1-29.5-76.1z"
      />
      {/* Green (top) */}
      <path
        fill="url(#gp-green)"
        d="M306.5 255.9L336 180l-263-152.1c-6.6-3.8-12.6-3.9-17.4-1.3l250.9 229.3z"
      />
    </svg>
  );
}
